import React from 'react';

import classes from './HeaderWithBorder.module.scss';

const HeaderWithBoarder = ({ header }) => <div className={classes.header}>{header}</div>;
export default HeaderWithBoarder;
